import React from 'react';
import { Box } from '@mui/material';

const MONO = "'IBM Plex Mono', monospace";

// Styled form input for auth pages
export default function AuthInput({ label, id, ...props }) {
  return (
    <Box sx={{ mb: 0 }}>
      {label && (
        <Box
          component="label"
          htmlFor={id}
          sx={{ display: 'block', fontFamily: MONO, fontSize: '11px', letterSpacing: '.1em', textTransform: 'uppercase', color: '#7f93b8', mb: '7px' }}
        >
          {label}
        </Box>
      )}
      <Box
        component="input"
        id={id}
        sx={{
          width: '100%',
          background: '#0c1a32',
          border: '1px solid rgba(120,150,200,.26)',
          borderRadius: '9px',
          p: '12px 14px',
          color: '#eaf0fb',
          fontSize: '14.5px',
          fontFamily: "'Lexend', sans-serif",
          outline: 'none',
          boxSizing: 'border-box',
          transition: 'border-color .15s',
          '&:focus': { borderColor: '#2dd4bf' },
          '&::placeholder': { color: '#4f6a8a' },
        }}
        {...props}
      />
    </Box>
  );
}
